<main>
  <h2>Fast growing community</h2>
  <h3>Join top DevDAOs.</h3>
  <div id="logos">
    <img src="/assets/images/logos/akash.png" alt="akash logo" />
    <img src="/assets/images/logos/ceramic.png" alt="ceramic logo" />
    <img src="/assets/images/logos/dxdao.png" alt="dxdao logo" />
    <img src="/assets/images/logos/gnosis.png" alt="gnosis logo" />
    <img src="/assets/images/logos/makerdao.png" alt="makerdao logo" />
    <img src="/assets/images/logos/polygon.png" alt="polygon logo" />
    <img src="/assets/images/logos/snapshot.png" alt="snapshot logo" />
    <img src="/assets/images/logos/synthetix.png" alt="synthetix logo" />
    <img src="/assets/images/logos/textile.png" alt="textile logo" />
    <img src="/assets/images/logos/thegraph.png" alt="the graph logo" />
    <img src="/assets/images/logos/uma.png" alt="uma logo" />
    <img
      src="/assets/images/logos/walletconnect.png"
      alt="walletconnect logo"
    />
  </div>
</main>
